import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPfsenseComponent } from './simple-icons-pfsense.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPfsenseComponent ],
    exports:      [ SimpleIconsPfsenseComponent ],
    bootstrap:    []
})
export class SimpleIconsPfsenseModule {}
